import { ReviewShell } from "@/shell/review/ReviewShell";
import { GOALS_TABS } from "./tabs";

export default function GoalsReview() {
  return <ReviewShell title="Goal Board — Design review" tabs={GOALS_TABS} barePath="/goals/board" />;
}